import React from 'react';
import I18n from 'i18n-js';
import CoreLink from '../components/core_link';
import { buttonClassName } from '../rc/RCButton';
import { RCTextWithIcon } from '../rc/RCTextWithIcon/RCTextWithIcon';
import ArrowRightIcon from '../../design-system/icons/core/arrow-right.svg?component';
import { CTA } from '../elog/mparticle_tracker';

interface Props {
  href: string;
  text?: string;
  'aria-describedby'?: string;
}

export function OverflowingRowAction(props: Props) {
  return (
    <CoreLink
      className={buttonClassName({ variant: 'transparent' })}
      to={props.href}
      interactionType={CTA}
      aria-describedby={props['aria-describedby']}
    >
      <RCTextWithIcon svgComponent={ArrowRightIcon} placement="right">
        {props.text
          ? props.text
          : I18n.t('commons.seeMore')}
      </RCTextWithIcon>
    </CoreLink>
  );
}
